import './scss/main.scss'
import LoadingScreen from './LoadingScreen';
import React, {useEffect, useState} from 'react';
import Scene from './Scene'
import DataLoader from './components/loaders/DataLoader'
import MainControlPanel from "./components/ui/MainControlPanel";
import UIAPI from "./components/loaders/UIAPI";
import {useSnapshot} from "valtio";
import {state, configuratorState, resetConfiguratorState} from "./state";
import NavigationBar from './components/ui/navigation/NavigationBar';
import Options from './components/ui/configurator/Options';
import ConfiguratorInitialiser from "./components/ConfiguratorInitialiser"
import { Disclaimer } from './components/ui/Disclaimer';

const ScreenWarning = () => {
  return(
    <div className="screen-warning">
          <div className="warning mobile-warning">
            <p>Uh oh!</p>
            <p>This configurator is made for use on desktops!</p>
          </div>
      </div>
  )
}
export default function App() {
  const {isLoaded,loadingProgress, initialised,} = useSnapshot(state);

  DataLoader();

  if(initialised && isLoaded) return(
    <div className="app-page">
      <ScreenWarning/>
      {/* <NavigationBar/> */}
      {loadingProgress<70?<LoadingScreen/>:null}
      <div style={{display:"flex", flex:1, margin:"25px 110px 0 110px"}}>
        <Scene/>
        <Options/>
      </div>:
      {/* <MainControlPanel/> 
      <UIAPI/> */}
    </div>
  )
  else return (
    <div className="app-page">
      <ScreenWarning/>
      {/* <NavigationBar/> */}
      <ConfiguratorInitialiser/>
      <Disclaimer/>
    </div>
  );
}

